var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCsAction({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Status",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#e1e7e9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(3 3)",
    fill: "#9e1b32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5759",
    "data-name": "Path 5759",
    d: "M349.381,27.683a2.548,2.548,0,1,1,2.548-2.548A2.548,2.548,0,0,1,349.381,27.683Z",
    transform: "translate(-326.381 6.146)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5760",
    "data-name": "Path 5760",
    d: "M348.7,28.89a1.274,1.274,0,0,1-1.274-1.274V16.152a1.274,1.274,0,0,1,2.548,0V27.616A1.274,1.274,0,0,1,348.7,28.89Z",
    transform: "translate(-325.701 -2.706)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCsAction);
export default __webpack_public_path__ + "static/media/icon_cs_action.a15e9fc162de58d47af061df8141c974.svg";
export { ForwardRef as ReactComponent };